module.exports = __webpack_public_path__ + "img/book_service_content.835a89e9.png";